import React from 'react';
import { RequestProvider } from '@shootsta/common-react';
import { createAnalyticsEntryApi } from '../../../api';
import {
  IGetPublicAssetQuery,
  ICreateAnalyticsEntryQuery
} from '../interfaces';

import { getVisitorId, getSessionId } from '../utils';

interface Requests {
  // eslint-disable-next-line react/no-unused-prop-types
  getPublicAsset: IGetPublicAssetQuery;
  // eslint-disable-next-line react/no-unused-prop-types
  createAnalyticsEntry: ICreateAnalyticsEntryQuery;
}

interface WithCreateAnalyticsEntryProps {
  shareablePageId: string;
}

interface InjectedCreateAnalyticsEntryProps {
  createAnalyticsEntry: ICreateAnalyticsEntryQuery
}

// This fails tslint - whyyy

const withCreateAnalyticsEntry = <T extends Record<string, unknown>>(
  Component: React.ComponentType<T>
): React.FC<T & WithCreateAnalyticsEntryProps> => ({
    shareablePageId, ...props }: WithCreateAnalyticsEntryProps) => (
      <RequestProvider
        requests={{
          createAnalyticsEntry: createAnalyticsEntryApi(
            shareablePageId,
            getVisitorId(),
            getSessionId()
          )
        }}
      >
        {({ createAnalyticsEntry }: Requests) => (
          <Component
            createAnalyticsEntry={createAnalyticsEntry}
            {...props as T}
          />
        )}
      </RequestProvider>
  );

export default withCreateAnalyticsEntry;
